<template>
  <div>
    <v-tour name="myTour" :steps="steps"></v-tour>

    <div class="form_page settings_page settings_pageV2">

      <div class="form_page_cnt" v-bind:class="{ 'sidebar-page': isHelpSidebar() }">
        <div class="settings_section">

          <div class="settings_left" :class="{ '': [3].indexOf(getUserRoleId) <= -1 }">
            <div class="settings_left_cnt">
              <!-- <h4>Start Case Intake in Less than 10 Minutes</h4>
              <p>You can setup, review and change all the required account details and settings below.</p> -->
              <VuePerfectScrollbar ref="mainSidebarPs" class="scroll-area--main-sidebar pt-3" :settings="settings"
                @ps-scroll-y="psSectionScroll">
                <ul>



                  <li class="tour-step-1 sm" v-if="[3].indexOf(getUserRoleId) > -1"
                    :class="{ active: getActiveSettingTab == 'profile' }" @click="activateSettingTab('profile')">
                    <figure>
                      <img class="default" src="@/assets/images/icons/settings/user-profile.svg" />
                      <img class="active" src="@/assets/images/icons/settings/user-profile-active.svg" />
                    </figure>
                    <figcaption>Company Details</figcaption>
                  </li>

                  <li v-if="
                    [1, 2].indexOf(getUserRoleId) > -1 ||
                    ([3, 4].indexOf(getUserRoleId) > -1
                    )
                  " :class="{ active: getActiveSettingTab == 'usersRoles' }" @click="activateSettingTab('usersRoles')">
                    <figure>
                      <img class="default" src="@/assets/images/icons/settings/user_roles.svg" />
                      <img class="active" src="@/assets/images/icons/settings/user_roles-active.svg" />
                    </figure>
                    <figcaption>User Roles </figcaption>
                  </li>
                  <li v-if="
                    [1, 2].indexOf(getUserRoleId) > -1 ||
                    ([3, 4].indexOf(getUserRoleId) > -1
                    ) && false
                  " :class="{ active: getActiveSettingTab == 'userAssignment' }"
                    @click="activateSettingTab('userAssignment')">
                    <figure>
                      <img class="default" src="@/assets/images/icons/settings/user_roles.svg" />
                      <img class="active" src="@/assets/images/icons/settings/user_roles-active.svg" />
                    </figure>
                    <figcaption>Default User Assignment </figcaption>
                  </li>

                  <li class="tour-step-2" :class="{ active: getActiveSettingTab == 'workflow' }"
                    @click="activateSettingTab('workflow')">
                    <figure>
                      <img class="default" src="@/assets/images/icons/settings/WorkflowIcon.svg" />
                      <img class="active" src="@/assets/images/icons/settings/WorkflowIcon_active.svg" />
                    </figure>
                    <figcaption>Workflow</figcaption>
                  </li>
                  <li class="tour-step-3" v-if="[3, 4].indexOf(getUserRoleId) > -1"
                    :class="{ active: getActiveSettingTab == 'questionnarie' }"
                    @click="activateSettingTab('questionnarie')">
                    <figure>
                      <img class="default" src="@/assets/images/icons/settings/setup.svg" />
                      <img class="active" src="@/assets/images/icons/settings/setup-active.svg" />
                    </figure>
                    <figcaption>Case Configuration</figcaption>
                  </li>

                  <!-- <li v-if="[3,4].indexOf(getUserRoleId)>-1" :class="{'active':getActiveSettingTab=='users'}"
                    @click="activateSettingTab('users')">
                    <figure>
                      <img class="default" style="height: 22px;" src="@/assets/images/icons/settings/Users.svg" />
                      <img class="active" style="height: 22px;" src="@/assets/images/icons/settings/Users-active.svg" />
                    </figure>
                    <figcaption>Users</figcaption>
                  </li> -->

                  <li v-if="[3].indexOf(getUserRoleId) > -1"
                    :class="{ 'active': ['branchCreate', 'branchDetails', 'branchList'].indexOf(getActiveSettingTab) > -1 }"
                    @click="activateSettingTab('branchList')">
                    <figure>
                      <img class="default" style="height: 22px;" src="@/assets/images/icons/settings/branchs.svg" />
                      <img class="active" style="height: 22px;"
                        src="@/assets/images/icons/settings/branchs-active.svg" />
                    </figure>
                    <figcaption>Branches</figcaption>
                  </li>


                  <li v-if="[1, 2, 3, 4].indexOf(getUserRoleId) > -1"
                    :class="{ active: getActiveSettingTab == 'caseTypes' }" @click="activateSettingTab('caseTypes')">
                    <figure>
                      <img class="default" src="@/assets/images/icons/settings/case_type.svg" />
                      <img class="active" src="@/assets/images/icons/settings/case_type-active.svg" />
                    </figure>
                    <figcaption>Case Types</figcaption>
                  </li>

                  <li v-if="[1, 2].indexOf(getUserRoleId) > -1"
                    :class="{ active: getActiveSettingTab == 'formsAndLetters' }"
                    @click="activateSettingTab('formsAndLetters')">
                    <figure>
                      <img style="height: 25px; margin-left:-5px;" class="default"
                        src="@/assets/images/icons/settings/FormsLetters.svg" />
                      <img style="height: 25px; margin-left:-5px;" class="active"
                        src="@/assets/images/icons/settings/FormsLetters-active.svg" />
                    </figure>
                    <figcaption>Forms and Letters</figcaption>
                  </li>

                  <li v-if="[1, 2].indexOf(getUserRoleId) > -1"
                    :class="{ active: getActiveSettingTab == 'petitionConfigList' }"
                    @click="activateSettingTab('petitionConfigList')">
                    <figure>
                      <img class="default" src="@/assets/images/icons/settings/setup.svg" />
                      <img class="active" src="@/assets/images/icons/settings/setup-active.svg" />
                    </figure>
                    <figcaption>Case Configuration</figcaption>
                  </li>




                  <li v-if="[1].indexOf(getUserRoleId) > -1" :class="{
                    active: getActiveSettingTab == 'questionnaireTemplateList',
                  }" @click="activateSettingTab('questionnaireTemplateList')">
                    <figure>
                      <img class="default" src="@/assets/images/icons/settings/QuestionnaireTemplates.svg" />
                      <img class="active" src="@/assets/images/icons/settings/QuestionnaireTemplates-active.svg" />
                    </figure>
                    <figcaption>Questionnaire Templates</figcaption>
                  </li>

                  <li class="tou sm" v-if="[3, 4].indexOf(getUserRoleId) > -1"
                    :class="{ active: getActiveSettingTab == 'invoiceList' }"
                    @click="activateSettingTab('invoiceList')">
                    <figure>
                      <img class="default" src="@/assets/images/icons/settings/payments.svg" />
                      <img class="active" src="@/assets/images/icons/settings/payments-active.svg" />
                    </figure>
                    <figcaption>Billing & Payments</figcaption>
                  </li>

                  <li v-if="[3].indexOf(getUserRoleId) > -1" :class="{ 'active': getActiveSettingTab == 'socSettings' }"
                    @click="activateSettingTab('socSettings')">
                    <figure>
                      <img class="default" src="@/assets/images/icons/settings/soc.svg" />
                      <img class="active" src="@/assets/images/icons/settings/socactive.svg" />
                    </figure>
                    <figcaption>SOC Settings</figcaption>
                  </li>
                  <li v-if="[1, 2,3].indexOf(getUserRoleId) > -1"
                    :class="{ 'active': getActiveSettingTab == 'SignDocumentTemplates'}"
                    @click="activateSettingTab('SignDocumentTemplates')">
                    <figure>
                      <img class="default" style="height: 22px;" src="@/assets/images/icons/settings/branchs.svg" />
                      <img class="active" style="height: 22px;"
                        src="@/assets/images/icons/settings/branchs-active.svg" />
                    </figure>
                    <figcaption>Sign Document Templates</figcaption>
                  </li>
                  <li v-if="[3].indexOf(getUserRoleId) > -1 && getTenantTypeId != 2" :class="{ 'active': getActiveSettingTab == 'fillingFeeSettings' }"
                    @click="activateSettingTab('fillingFeeSettings')">
                    <figure>
                      <img class="default" src="@/assets/images/icons/settings/filingFee.svg" />
                      <img class="active" src="@/assets/images/icons/settings/filingFee_active.svg" />
                    </figure>
                    <figcaption>Filing Fees</figcaption>
                  </li>


                  <li v-if="
                    (
                      [3, 4].indexOf(getUserRoleId) > -1 &&
                      [3, 4].indexOf(getUserRoleId) > -1
                      ) || ([1].indexOf(getUserRoleId) > -1)
                  " :class="{ active: getActiveSettingTab == 'quickbooksSettings' }"
                    @click="activateSettingTab('quickbooksSettings')">
                    <figure>
                      <img class="default" src="@/assets/images/icons/settings/settings.svg" />
                      <img class="active" src="@/assets/images/icons/settings/settings-active.svg" />
                    </figure>
                    <figcaption>Settings</figcaption>
                  </li> 
                  <li v-if="
                    (
                      [3, 4].indexOf(getUserRoleId) > -1 &&
                      [3, 4].indexOf(getUserRoleId) > -1
                      ) || ([1].indexOf(getUserRoleId) > -1)
                  " :class="{ active: getActiveSettingTab == 'configReminders' }"
                    @click="activateSettingTab('configReminders')">
                    <figure>
                      <img class="default" src="@/assets/images/icons/settings/setup.svg" />
                      <img class="active" src="@/assets/images/icons/settings/setup-active.svg" />
                    </figure>
                    <figcaption>Reminders</figcaption>
                  </li>

                  

                  <li v-if="[1,2,3, 4].indexOf(getUserRoleId) > -1"
                    :class="{ 'active': getActiveSettingTab == 'servicesCenters' }"
                    @click="activateSettingTab('servicesCenters')">
                    <figure>
                      <img class="default" style="height: 22px;" src="@/assets/images/icons/settings/Services.svg" />
                      <img class="active" style="height: 22px;"
                        src="@/assets/images/icons/settings/Services-active.svg" />
                    </figure>
                    <figcaption>Service Centers</figcaption>
                  </li>
                  <li v-if="[1, 3, 4].indexOf(getUserRoleId) > -1"
                    :class="{ 'active': getActiveSettingTab == 'caseCodeConfig' }"
                    @click="activateSettingTab('caseCodeConfig')">
                    <figure>
                      <img class="default" style="height: 22px;" src="@/assets/images/icons/settings/Config.svg"
                        height="20" />
                      <img class="active" style="height: 22px;"
                        src="@/assets/images/icons/settings/Config-active.svg" />
                    </figure>
                    <figcaption>Case Code Configuration</figcaption>
                  </li>
                  <li v-if="[3].indexOf(getUserRoleId) > -1"
                    :class="{ 'active': getActiveSettingTab == 'consentTerm' }"
                    @click="activateSettingTab('consentTerm')">
                    <figure>
                      <img class="default" style="height: 22px;" src="@/assets/images/icons/settings/consent.svg" />
                      <img class="active" style="height: 22px;"
                        src="@/assets/images/icons/settings/consent-active.svg" />
                    </figure>
                    <figcaption>Consent Content</figcaption>
                  </li>
                  <li 
                    :class="{ 'active': getActiveSettingTab == 'labelsList' }"
                    @click="activateSettingTab('labelsList')">
                    <figure>
                      <img class="default" style="width:16px;height: auto;" src="@/assets/images/icons/settings/price-tag-active.png" />
                      <img class="active" style="width:16px;height: auto;"
                        src="@/assets/images/icons/settings/price-tag.png" />
                    </figure>
                    <figcaption>Labels</figcaption>
                  </li>
                  




                  <!--
                  
                <li :class="{'active':getActiveSettingTab=='users'}" @click="activateSettingTab('users')">
                  <figure><img src="@/assets/images/icons/settings/Users.svg"></figure>
                  <figcaption>Users</figcaption>
                </li>
                -->
                  <!-- <li :class="{'active':getActiveSettingTab=='formsandletters'}"  @click="activateSettingTab('formsandletters')">
                  <figure>
                    <img class="default"  src="@/assets/images/icons/settings/FormsLetters.svg">
                    <img class="active" src="@/assets/images/icons/settings/FormsLetters-active.svg">
                  </figure>
                  <figcaption>Forms &amp; Letters</figcaption>
                </li>
                <li :class="{'active':getActiveSettingTab=='cases'}" @click="activateSettingTab('cases')">
                  <figure>
                    <img class="default"  src="@/assets/images/icons/settings/Documents.svg">
                    <img class="active" src="@/assets/images/icons/settings/Documents-active.svg">
                  </figure>
                  <figcaption>Cases</figcaption>
                </li>  -->
                </ul>
              </VuePerfectScrollbar>
            </div>
          </div>
          <div class="settings_right_wrap">
            <template v-if="getActiveSettingTab == 'invoiceList'">
              <invoiceList @activateSettingTab="activateSettingTab" @startTour="startTour" />
            </template>

            <template v-if="getActiveSettingTab == 'profile'">
              <tenantProfile @activateSettingTab="activateSettingTab" />
            </template>
            <template v-if="getActiveSettingTab == 'workflow'">
              <workFlowsettings @showSetupCompleted="showSetupCompleted" @activateSettingTab="activateSettingTab" />
            </template>
            <template v-if="
              getActiveSettingTab == 'questionnarie' ||
              getActiveSettingTab == 'formsandletters' ||
              getActiveSettingTab == 'cases'
            ">
              <questionnarieSettings @activateSettingTab="activateSettingTab" />
            </template>

            <template v-if="
              getActiveSettingTab == 'usersRoles' &&
              [1, 2, 3, 4].indexOf(getUserRoleId) > -1
            ">
              <usersRoles @activateSettingTab="activateSettingTab" />
            </template>
            <!-- userAssignment -->
            <template v-if="
              getActiveSettingTab == 'userAssignment' && false &&
              [1, 2, 3, 4].indexOf(getUserRoleId) > -1
            ">
              <defaultUserAssignment @activateSettingTab="activateSettingTab" />
            </template>


            <template v-if="getActiveSettingTab == 'caseTypes'">
              <caseTypes @activateSettingTab="activateSettingTab" />
            </template>

            <template v-if="
              getActiveSettingTab == 'formsAndLetters' &&
              [1, 2].indexOf(getUserRoleId) > -1
            ">
              <formsAndLetters @activateSettingTab="activateSettingTab" />
            </template>

            <template v-if="getActiveSettingTab == 'petitionConfigList'">
              <petitionConfigList @activateSettingTab="activateSettingTab" />
            </template>

            <template v-if="getActiveSettingTab == 'quickbooksSettings'">
              <quickbooksSettings @activateSettingTab="activateSettingTab" />
            </template> 
            <template v-if="getActiveSettingTab == 'configReminders'">
              <!-- <configRemindars @activateSettingTab="activateSettingTab" /> -->
               <configReminder @activateSettingTab="activateSettingTab"/>
            </template>
            <template v-if="getActiveSettingTab == 'consentTerm'">
               <consentTerms />
            </template>
            <template v-if="
              getActiveSettingTab == 'questionnaireTemplateList' &&
              [1].indexOf(getUserRoleId) > -1
            ">
              <questionnaireTemplateList @activateSettingTab="activateSettingTab" />
            </template>
            <template v-if="
              getActiveSettingTab == 'socSettings' &&
              [3, 4].indexOf(getUserRoleId) > -1
            ">
              <socSettings @activateSettingTab="activateSettingTab" />
            </template>
            <template v-if="getActiveSettingTab == 'servicesCenters' && [1,2,3, 4].indexOf(getUserRoleId) > -1">
              <servicesCenters @activateSettingTab="activateSettingTab" />
            </template>
            <template v-if="getActiveSettingTab == 'caseCodeConfig' && [1, 3, 4].indexOf(getUserRoleId) > -1">
              <caseCodeConfig @activateSettingTab="activateSettingTab" />
            </template>
            <template v-if="getActiveSettingTab == 'labelsList' ">
              <labelsList @activateSettingTab="activateSettingTab" />
            </template>

            <template v-if="getActiveSettingTab == 'users' && [3, 4].indexOf(getUserRoleId) > -1">
              <div class="settings_users">
                <Users @activateSettingTab="activateSettingTab" />
              </div>
            </template>
            <template v-if="getActiveSettingTab == 'branchList' && [3, 4].indexOf(getUserRoleId) > -1">
              <div class="settings_branches">
                <branchList @activateSettingTab="activateSettingTab" @branchActions="branchActions" />
              </div>
            </template>
            <template v-if="getActiveSettingTab == 'SignDocumentTemplates' && [1, 2 ,3, 4].indexOf(getUserRoleId) > -1">
              <div class="settings_branches">
                <signDocsList @activateSettingTab="activateSettingTab"/>
              </div>
            </template>
            <template v-if="getActiveSettingTab == 'branchCreate' && [3, 4].indexOf(getUserRoleId) > -1">
              <div class="settings_branchcreate">
                <branchCreate :isLoadedFromUrl="false" :selectedBranch="selectedBranch" />
              </div>
            </template>
            <template v-if="getActiveSettingTab == 'branchDetails' && [3, 4].indexOf(getUserRoleId) > -1">
              <div class="settings_branchdetails">
                <BranchDetails :isLoadedFromUrl="false" :selectedBranch="selectedBranch" />
              </div>
            </template>
            <template v-if="getActiveSettingTab == 'fillingFeeSettings' && [1,2,3, 4].indexOf(getUserRoleId) > -1">
              <fillingFeeSettings @activateSettingTab="activateSettingTab" />
            </template>
          </div>
          <the-footer v-if="checkProperty($route, 'name') == 'basic-settings'"></the-footer>
        </div>
      </div>


      <vs-popup class="holamundo success-popups" title="Congratulations!" :active.sync="setupCompletedPopup">
        <figure>
          <img src="@/assets/images/main/icon-note.svg" alt="login" class="mx-auto" />
        </figure>
        <h2 class="title">Congratulations!</h2>
        <p>
          {{ setupCompletedPopupmessage }}
        </p>
      </vs-popup>

      <div class="right_bar" v-if="isHelpSidebar()">

        <ul>

          <li v-if="getActiveSettingTab == 'invoiceList'">
            <label>Payments</label>
            <p>
              Provide the billing (card details) information, you will not be charged until start filing the cases.
              Every end of the month you will be charged based on the cases count. Check our pricing page for more
              information.

            </p>
          </li>
          <li v-if="getActiveSettingTab == 'profile'">
            <label>Profile</label>
            <p>
              Setup profile by filling required information mentioned in the form like Account Domain, Logo, Company
              Short Code and Office address etc.

            </p>
          </li>
          <li v-if="getActiveSettingTab == 'workflow'">
            <label>Workflow</label>
            <p>
              Workflow configuration is the place to decide the Case flow and it will give you such a flexibility to
              handle the entire flow with limited resource available with you.

            </p>
          </li>
          <li v-if="getActiveSettingTab == 'questionnarie'">
            <label>Case Configuration</label>
            <p>
              Case Configuration is the place where you can configure Workflow, Questionnaire and and forms and letters
              for Case type and Sub type.

            </p>
          </li>
          <li v-if="getActiveSettingTab == 'usersRoles'">
            <label>User Roles</label>
            <p>
              It will give flexibility to change the default roles names as per your convenient.

            </p>
          </li>

          <li v-if="getActiveSettingTab == 'userAssignment' && false">
            <label>Default User Assignment</label>
            <p>
              Default User Assignment.

            </p>
          </li>
          <li v-if="getActiveSettingTab == 'quickbooksSettings'">
            <label>QuickBooks</label>
            <p>
              QuickBooks Configuration will allow you to configure your own QuickBooks Account to sync Invoices were
              generated from ImmiBox Portal.
            </p>
            <p>
            </p>
          </li>

          <li v-if="getActiveSettingTab == 'socSettings'">
            <label>SOC Settings</label>
            <p>
              SOC Settings TEXT HERE

            </p>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import Datepicker from "vuejs-datepicker-inv";
import VuePhoneNumberInput from "vue-phone-number-input";
import "vue-phone-number-input/dist/vue-phone-number-input.css";
import FileUpload from "vue-upload-component/src";
import * as _ from "lodash";
import { InfoIcon } from "vue-feather-icons";
import tenantProfile from "@/views/tenant/editProfile.vue";
import workFlowsettings from "@/views/tenant/workFlowsettings.vue";
import questionnarieSettings from "@/views/tenant/questionnarieSettings.vue";
import usersSettings from "@/views/tenant/usersSettings.vue";
import formsandlettersSettings from "@/views/tenant/formsandlettersSettings.vue";
import caseTypeSettings from "@/views/tenant/caseTypeSettings.vue";

import usersRoles from "@/views/usersRoles.vue";
import defaultUserAssignment from "@/views/defaultUserAssignment.vue";

import petitionConfigList from "@/views/petitionConfigList.vue";
import quickbooksSettings from "@/views/QuickbookConfigration.vue";
import formsAndLetters from "@/views/forms-letters.vue";
import invoiceList from "@/views/invoiceList.vue";

import questionnaireTemplateList from "@/views/questionnaireTemplateList.vue";
import caseTypes from "@/views/petitiontypes/caseList.vue";
import socSettings from "@/views/tenant/socSettings.vue";
import servicesCenters from "@/views/tenant/servicesCenters.vue";

import caseCodeConfig from "@/views/tenant/caseCodeConfig.vue";
import labelsList from "@/views/messages/labelsList.vue";
import JQuery from "jquery";
import Users from "@/views/Users.vue";
import branchList from "@/views/branchList.vue";
import branchCreate from "@/views/branchCreate.vue";

import BranchDetails from "@/views/BranchDetails.vue";
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import TheFooter from "@/layouts/components/TheFooter.vue";

//import configRemindars from "../configRemindars.vue";
import configReminder from '../configReminder.vue'
import fillingFeeSettings from "@/views/tenant/fillingFeeSettings.vue";

import signDocsList from "../globalSettings/signDocumentTemplates.vue";
import consentTerms from "@/views/tenant/consentTerms.vue";
export default {
  name: "the-navbar",
  props: {
    navbarColor: {
      type: String,
      default: "#fff",
    },
  },
  data() {
    return {
      selectedBranch: null,
      branchActionType: '',
      settings: {
        swipeEasing: true,
      },
      steps: [
        // {
        //   target: ".tour-step-1",
        //   header: {
        //     title: "Get Started IMMIBOX",
        //   },
        //   content: `You can setup, review and change all the required account details and settings here.`,
        //   params: {
        //     enableScrolling: false,
        //     placement: "top-start",
        //   },
        // },
        {
          target: ".tour-step-1",
          header: {
            title: "Get Started ImmiBox",
          },
          content: `You can setup, review and change all the required account details and settings here.`,
          params: {
            enableScrolling: false,
            placement: "top-start",
          },
        },
        {
          target: ".tour-step-2",
          header: {
            title: "A Flexible Workflow as you want",
          },
          content: "Configure the workflow based on your organization flow.",
          params: {
            enableScrolling: false,
            placement: "top-start",
          },
        },
        {
          target: ".tour-step-3",
          header: {
            title: "Questionnaire, Forms and Letters",
          },
          content:
            "Configure Questionnaire and Forms and Letters here for case types and subtypes",
          params: {
            enableScrolling: false,
            placement: "top-start",
          },
        },
      ],
      tenantDetails: null,
      defaultWorkflowId: null,
      setupCompletedPopup: false,
      setupCompletedPopupmessage: null,
      workflowDetailsData: null,
      settings: {

        // wheelSpeed: 0.6,
        // height: 100,
      },
    };
  },
  watch: {
    isdefaultWorkflowComplted(newVal, oldVal) {
      if (newVal === false && this.getActiveSettingTab != 'invoiceList') {
        this.$tours["myTour"].start();
      }
    },
  },
  mounted() {

    this.activateSettingTab("profile");




    if ([1, 2].indexOf(this.getUserRoleId) > -1) {
      this.activateSettingTab("workflow");
      this.startTour();
    } else {
      if ([3, 4].indexOf(this.getUserRoleId) > -1) {
        if (this.checkProperty(this.$route, 'query', 'tab')) {
          this.$store.dispatch("common/activateSettingTab", this.checkProperty(this.$route, 'query', 'tab'));
          this.tenantCurrentPlan(false);

        } else {
          this.tenantCurrentPlan();
        }

      } else {


        this.activateSettingTab("profile");
        this.startTour();



      }




    }
    setTimeout(()=>{
      this.setReminderTab();
    }, 1000)
  },
  computed: {
    getIsCardExists() {
      return this.$store.getters['subscription/getIsCardExists']
    },

    getCurrentPlan() {
      return this.$store.getters['subscription/getCurrentPlan']
    },


    getActiveSettingTab() {
      try {
        return this.$store.getters["common/getActiveSettingTab"];
      } catch (er) {
        return "profile";
      }
    },
  },
  methods: {
    setReminderTab(){
      let rout = this.$route
      if(this.checkProperty(rout, 'params') && this.checkProperty(rout, 'params', 'tabName') && [3, 4].indexOf(this.getUserRoleId) > -1){
        let tabNam = this.checkProperty(rout, 'params', 'tabName');
        this.activateSettingTab(tabNam);
      }
    },
    psSectionScroll(e) {

    },

    branchActions(data) {
      this.selectedBranch = this.checkProperty(data, 'selectedBranch');
      this.branchActionType = this.checkProperty(data, 'branchActionType');
      if (this.branchActionType) {

        this.$store.dispatch("common/activateSettingTab", this.branchActionType);
      }

    },
    startTour() {
      if (this.isdefaultWorkflowComplted === false) {
        this.$tours["myTour"].start();
      }
    },

    tenantCurrentPlan(setTab = true) {
      this.userplan = null;
      var user = this.getUserData
      let self = this;
      let tenantDetails = self.checkProperty(user, "tenantDetails")
      let subscriber = {
        name: self.checkProperty(tenantDetails, "adminName"),
        email: self.checkProperty(tenantDetails, "adminEmail"),
        phone: self.checkProperty(tenantDetails, "phone"),
        phoneCode: self.checkProperty(tenantDetails, "phoneCountryCode", "countryCallingCode")
      }

      var payLoad = {
        selPlanIds: [],
        plans: [],
        source: null,
        serviceTypeId: 1,
        methodTypeId: 1,
        newSource: true,
        subscriber: subscriber,
        today: moment(new Date()).format("YYYY-MM-DD"),
        timezone: moment.tz.guess(),
        browserTS: moment(new Date())
      };

      this.$store.dispatch("subscription/getSelectedPlan", payLoad).then((currentPlan) => {

        if (currentPlan && this.checkProperty(currentPlan, 'length') > 0) {

          this.$store.commit("subscription/updateCurrentPlan", currentPlan[0]);
          if (setTab) {
            this.activateSettingTab("profile");
            this.startTour();
          }



        } else {
          if (setTab) {
            
           // this.activateSettingTab("workflow");
            // if card Details is mandatory enable below line
           // this.activateSettingTab("invoiceList");
          }
        }
      }).catch((err) => {
        if (setTab) {
          
         
        //  this.activateSettingTab("workflow");
          // if card Details is mandatory enable below line
           //this.activateSettingTab("invoiceList");
        }
      })

    },
    activateSettingTab(tab) {
      if ([1, 2].indexOf(this.getUserRoleId) > -1) {
        this.$store.dispatch("common/activateSettingTab", tab);
        //  alert(tab)
      } else {

        if (([3, 4].indexOf(this.getUserRoleId) > -1) && ((this.getIsCardExists == 'false' || this.getIsCardExists == false) || !this.checkProperty(this.getCurrentPlan, "_id"))) {
          //this.$store.dispatch("common/activateSettingTab", tab);
          // if card Details is mandatory enable below line
         // this.$store.dispatch("common/activateSettingTab", 'invoiceList');

         if(tab != 'profile' && (
            (this.$store.state.user['roleId'] == 3 && (this.$store.state.tenantProfileCompleted == false ))
            || (this.$store.state.user['roleId'] == 50 && this.$store.state.petitionerProfileCompleted == false)
           )
            ){
              this.$store.dispatch("common/activateSettingTab", 'profile');
            //  this.activateSettingTab('profile');
              //getActiveSettingTab != 'profile'

          }else if (tab) {
            this.$store.dispatch("common/activateSettingTab", tab);
          }

        } else {
         
          if(tab != 'profile' && (
            (this.$store.state.user['roleId'] == 3 && (this.$store.state.tenantProfileCompleted == false ))
            || (this.$store.state.user['roleId'] == 50 && this.$store.state.petitionerProfileCompleted == false)
           )
            ){
              this.$store.dispatch("common/activateSettingTab", 'profile');
            //  this.activateSettingTab('profile');
              //getActiveSettingTab != 'profile'

          }else if (tab) {
            this.$store.dispatch("common/activateSettingTab", tab);
          }

          this.getTenantDetails(tab);

        }

      }

      const $ = JQuery;
      $("html, body").animate(
        {
          scrollTop: 0,
        },
        100
      );
    },
    getTenantDetails(tab = "") {



      let postData = {
        tenantId: this.getUserData["tenantDetails"]["_id"],
      };
      this.$store
        .dispatch("get_tenant_details", postData)
        .then((response) => {
          this.tenantDetails = response;

          //petConfigCompleted //defaultWorkflowComplted



          if (
            tab != "" &&
            this.checkProperty(this.tenantDetails, "profCompleted") == "Yes" &&
            tab == "workflow"
            //&& !this.checkProperty(this.tenantDetails, "defaultWorkflowComplted")
          ) {
            this.$store.dispatch("common/activateSettingTab", tab);
          } else if (
            this.checkProperty(this.tenantDetails, "defaultWorkflowId")
          ) {
            this.defaultWorkflowId = this.tenantDetails["defaultWorkflowId"];
            this.getworkflowDetails(tab);
          }
          if (
            this.checkProperty(this.tenantDetails, "profCompleted") == "Yes" &&
            this.checkProperty(this.tenantDetails, "defaultWorkflowComplted")
          ) {
            this.$store.dispatch("common/activateSettingTab", tab);
          }
        })
        .catch((error) => { });
    },
    getworkflowDetails(tab) {
      let postData = { workflowId: this.defaultWorkflowId };
      this.$store
        .dispatch("commonAction", { data: postData, path: "/workflow/details" })
        .then((response) => {
          //alert(JSON.stringify(response));
          if (response) {
            this.workflowDetailsData = response;
            if (
              this.checkProperty(this.workflowDetailsData, "configCompleted") &&
              this.checkProperty(this.workflowDetailsData, "active")
            ) {
              this.$store.dispatch("common/activateSettingTab", tab);
            }
          }
        });
    },
    isHelpSidebar() {
      if (this.getActiveSettingTab != 'caseTypes' && [3].indexOf(this.getUserRoleId) > -1) {
        return true;
      }
      return false;
    },
    showSetupCompleted(response) {
      this.setupCompletedPopup = true;
      this.setupCompletedPopupmessage = response.message
    }
  },
  directives: {},
  components: {
    consentTerms,
    signDocsList,
    fillingFeeSettings,
    labelsList,
    caseCodeConfig,
    branchCreate,
    BranchDetails,
    branchList,
    Users,
    servicesCenters,
    VuePhoneNumberInput,
    FileUpload,
    invoiceList,
    moment,
    Datepicker,
    InfoIcon,
    tenantProfile,
    workFlowsettings,
    questionnarieSettings,
    usersSettings,
    formsandlettersSettings,
    caseTypeSettings,
    TheFooter,
    defaultUserAssignment,
    usersRoles,
    caseTypes,
    petitionConfigList,
    quickbooksSettings,
    formsAndLetters,
    questionnaireTemplateList,
    VuePerfectScrollbar,
    socSettings,
    configReminder
  },
};
</script>